import i18next from 'i18next';
import { useMutation } from 'react-query';
import { GenericResponse } from '../../../interfaces/shared.interface';
import { setToast } from '../../../store/core/coreSlice';
import { store } from '../../../store/store';
import { apiRQ } from '../../api';
import { queryClient } from '../../APIProvider';

interface DataDTO {
  entityId: string;
  email: string;
}

const sendEmailService = async (data: DataDTO): Promise<GenericResponse> => {
  const resp = await apiRQ.post<GenericResponse>('/money-collection/send-custom-email', data);
  return resp.data;
};

export const useSendMoneyCollectionEmail = () => {
  return useMutation<GenericResponse, Error, DataDTO>(sendEmailService, {
    onSuccess: (data) => {
      if (data.success) {
        store.dispatch(
          setToast({
            value: { show: true, msg: i18next.t('SHARED.SEND_EMAIL_SUCCESS'), position: 'top', override: true },
          }),
        );
      }
    },
    onError: () => {
      store.dispatch(
        setToast({
          value: {
            show: true,
            msg: i18next.t('SHARED.SOMETHING_WENT_WRONG'),
            position: 'top',
            override: true,
            isError: true,
          },
        }),
      );
    },
    onSettled: () => {
      queryClient?.invalidateQueries({ queryKey: ['useMoneyCollection'] });
    },
  });
};
